import { OrgRole } from "@hex/common";

import { useCurrentUserIsRoleOrAbove } from "./useCurrentUserIsRoleOrAbove.js";

/**
 * Returns true if the current user is an admin.
 */
export const useCurrentUserIsAdmin = (): boolean => {
  return useCurrentUserIsRoleOrAbove(OrgRole.ADMIN);
};
